// Запоминает векторные источники, у которых был сбой загрузки тайла, чтобы при
// возврате во вкладку перезапрашивать только их, а не все подряд.
export function createSourceErrorTracker() {
  const failed = new Set<string>();
  return {
    note(sourceId: string | undefined) {
      if (sourceId) failed.add(sourceId);
    },
    drain(): string[] {
      const ids = [...failed];
      failed.clear();
      return ids;
    },
  };
}
